import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import apiClient from 'utils/apiClient';

export interface PlatformHistoryState {
    histories: PlatformHistoryProps[]
    loading: boolean
}

export interface PlatformHistoryProps {
    checked_at: number
    [key: string]: any
}

export const initialState: PlatformHistoryState = {
    histories: [],
    loading: false
};

export const searchPlatformHistories = createAsyncThunk<PlatformHistoryProps[], { accountDetailUuid: string, lteDate?: string }, { state: RootState }>(
    'platformHistory/search',
    async (params, { rejectWithValue }) => {
        const { accountDetailUuid, lteDate } = params;
        if (!accountDetailUuid) return;

        let url = `/api/history/platform?accountDetailUuid=${encodeURIComponent(accountDetailUuid)}`;
        if (lteDate) url += `&lteDate=${encodeURIComponent(lteDate)}`;

        try {
            const response = await apiClient.get(url);
            return response.data.records;
        } catch (e: any) {
            return rejectWithValue(e?.response?.data?.msg || 'Failed to fetch platform history');
        }
    },
    {
        condition: (_, { getState }) => {
            const { loading } = (getState() as RootState).platformHistory as PlatformHistoryState;
            return !loading;
        }
    }
)

const platformHistorySlice = createSlice({
    name: "platformHistory",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(searchPlatformHistories.pending, (state) => {
                state.loading = true;
            })
            .addCase(searchPlatformHistories.fulfilled, (state, action) => {
                state.loading = false;
                if (!action.payload) return;
                // API returns ASC, reverse to get DESC (newest first)
                state.histories = [...action.payload].reverse();
            })
            .addCase(searchPlatformHistories.rejected, (state) => {
                state.loading = false;
            })
    },
    reducers: {
        refresh: () => initialState,
    }
})

export const {
    refresh
} = platformHistorySlice.actions;
export default platformHistorySlice.reducer;
